import React from 'react';
import { Link, useNavigate, useLocation, useParams } from 'react-router-dom';
import { 
  SidebarSimple, 
  User, 
  Question,
  Gear,
  SignOut,
  Info,
  Article,
  Lock
} from '@phosphor-icons/react';
import { Menu } from '@headlessui/react';
import { Logo } from './Logo';
import { useChatStore } from '../../store/chatStore';
import { useAuth } from '../../contexts/AuthContext';
import { useBibleStore } from '../../store/bibleStore';
import { ChatHeader } from '../../../features/chat/components/ChatHeader';

export function Header() {
  const { setDrawerOpen } = useChatStore();
  const navigate = useNavigate();
  const location = useLocation();
  const { id: chatId } = useParams();
  const { signOut } = useAuth();
  const { isInfoSidebarOpen } = useBibleStore();

  const isOnChatPage = location.pathname.startsWith('/chat/');
  const isOnHomePage = location.pathname === '/';

  const handleMouseEnter = () => {
    setDrawerOpen(true);
  };

  const handleLogout = async () => {
    try {
      await signOut();
      navigate('/login');
    } catch (error) {
      console.error('Failed to sign out:', error);
    }
  };

  const handleShare = () => {
    if (window.openShareDialog) {
      window.openShareDialog();
    }
  };

  return (
    <header className={`fixed top-0 left-0 transition-all duration-300 h-[60px] bg-gradient-to-b from-[rgba(250,250,250,1)] to-[rgba(250,250,250,0)] z-50 ${
      isInfoSidebarOpen ? 'right-[320px]' : 'right-0'
    }`}>
      <div className="h-full w-full px-4 flex items-center justify-between">
        <div 
          onMouseEnter={handleMouseEnter}
          className="p-2 hover:bg-[rgba(0,0,0,0.05)] rounded-lg cursor-pointer"
        >
          <SidebarSimple size={24} className="text-[#361E06]" weight="bold" />
        </div>

        {!isOnChatPage && (
          <div 
            onClick={() => navigate('/')}
            className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 cursor-pointer"
          >
            <Logo size={32} className="text-[#361E06]" />
          </div>
        )}

        <div className="flex items-center space-x-2">
          {isOnHomePage && (
            <Menu as="div" className="relative">
              <Menu.Button className="p-2 hover:bg-[rgba(0,0,0,0.05)] rounded-lg">
                <Question size={24} className="text-[#361E06]" weight="bold" />
              </Menu.Button>
              <Menu.Items className="absolute right-0 mt-1 w-48 bg-white rounded-md shadow-lg border border-gray-200 focus:outline-none z-50">
                <Menu.Item>
                  {({ active }) => (
                    <Link
                      to="/support"
                      className={`${
                        active ? 'bg-gray-50 text-gray-900' : 'text-gray-700'
                      } flex items-center px-4 py-2 text-sm`}
                    >
                      <Info className="w-4 h-4 mr-2" weight="bold" />
                      Help & FAQ
                    </Link>
                  )}
                </Menu.Item>
                <Menu.Item>
                  {({ active }) => (
                    <Link
                      to="/terms"
                      className={`${
                        active ? 'bg-gray-50 text-gray-900' : 'text-gray-700'
                      } flex items-center px-4 py-2 text-sm`}
                    >
                      <Article className="w-4 h-4 mr-2" weight="bold" />
                      Terms of Service
                    </Link>
                  )}
                </Menu.Item>
                <Menu.Item>
                  {({ active }) => (
                    <Link
                      to="/privacy"
                      className={`${
                        active ? 'bg-gray-50 text-gray-900' : 'text-gray-700'
                      } flex items-center px-4 py-2 text-sm`}
                    >
                      <Lock className="w-4 h-4 mr-2" weight="bold" />
                      Privacy Policy
                    </Link>
                  )}
                </Menu.Item>
              </Menu.Items>
            </Menu>
          )}

          {isOnChatPage ? (
            chatId ? <ChatHeader onShare={handleShare} chatId={chatId} /> : null
          ) : (
            <Menu as="div" className="relative">
              <Menu.Button className="p-2 hover:bg-[rgba(0,0,0,0.05)] rounded-lg">
                <User size={24} className="text-[#361E06]" weight="bold" />
              </Menu.Button>
              <Menu.Items className="absolute right-0 mt-1 w-48 bg-white rounded-md shadow-lg border border-gray-200 focus:outline-none z-50">
                <Menu.Item>
                  {({ active }) => (
                    <button
                      onClick={() => navigate('/account')}
                      className={`${
                        active ? 'bg-gray-50 text-gray-900' : 'text-gray-700'
                      } flex w-full items-center px-4 py-2 text-sm`}
                    >
                      <Gear className="w-4 h-4 mr-2" weight="bold" />
                      Settings
                    </button>
                  )}
                </Menu.Item>
                <Menu.Item>
                  {({ active }) => (
                    <button
                      onClick={handleLogout}
                      className={`${
                        active ? 'bg-gray-50 text-gray-900' : 'text-gray-700'
                      } flex w-full items-center px-4 py-2 text-sm`}
                    >
                      <SignOut className="w-4 h-4 mr-2" weight="bold" />
                      Sign out
                    </button>
                  )}
                </Menu.Item>
              </Menu.Items>
            </Menu>
          )}
        </div>
      </div>
    </header>
  );
} 